<section *ngIf="content$ | finMap: 'tabs' | async as tabs">
  <div class="pr-xxsmall-x">
    <h3 class="font-heading-3">{{ content$ | finMap: 'teaserTitle' | async }}</h3>
    <div class="pr-xsmall-y" [innerHTML]="content$ | finMap: 'teaserText' | async | finSafe: 'html'"></div>
  </div>

  <div role="tablist" class="tablist">
    <div *ngFor="let tab of tabs" class="tab flex flex--column flex--align-stretch overflow-hidden">
      <button
        class="flex-1 fill border font-body-1"
        #element
        role="tab"
        [class.nordic-blue-900-bg]="(currentTab$ | async) === tab"
        [class.nordic-blue-900-text]="(currentTab$ | async) !== tab"
        [class.white-text]="(currentTab$ | async) === tab"
        [id]="'tab-' + tab.content.contentId"
        [attr.tabindex]="(currentTab$ | async) === tab ? undefined : '-1'"
        [attr.aria-controls]="'tab-' + tab.content.contentId + '-content'"
        [attr.aria-selected]="(currentTab$ | async) === tab"
        (click)="selectTab(tab)"
        (keyup)="handleKeyPress($event, element)"
      >
        <span class="align-left flex flex--center">
          <span class="pr-xsmall-l flex--basis0" *ngIf="tab.iconUrl">
            <img
              class="valign-middle"
              alt=""
              [attr.src]="tab.iconUrl | finSafe: 'resource'"
              [style.height.em]="2"
              [style.width]="'auto'"
            />
          </span>
          <span class="pr-xsmall flex-1 break-word overflow-hidden">{{ tab.title }}</span>
          <span class="flex--basis0" *ngIf="!tab.iconUrl && tab.picture">
            <img
              class="valign-middle"
              alt=""
              [attr.src]="tab.picture.responsiveImageLinksData['768'].portrait_ratio1x1 | finSafe: 'resource'"
              [style.height.em]="3"
              [style.width]="'auto'"
            />
          </span>
        </span>
      </button>
    </div>
  </div>

  <div
    *ngFor="let tab of tabs"
    tabindex="0"
    role="tabpanel"
    [id]="'panel-' + tab.content.contentId"
    [class.is-hidden]="(currentTab$ | async) !== tab"
    [attr.aria-labelledby]="'tab-' + tab.content.contentId"
    [attr.aria-hidden]="(currentTab$ | async) !== tab"
  >
    <fin-cms-json-content [template$]="{ main: [tab.content] } | finToObservable"></fin-cms-json-content>
  </div>
</section>
